import { CorrlinksParams, SendEmailVerificationDto } from "@awc/models";
import { createAction } from "@reduxjs/toolkit";

export const SEND_USER_EMAIL_VERIFICATION = createAction<SendEmailVerificationDto>("SEND_USER_EMAIL_VERIFICATION");
export const CHECK_TOKEN_ISVALID = createAction<string>("CHECK_TOKEN_ISVALID");
export const AUTHENTICATE_CORRLINKS_USER = createAction<CorrlinksParams>("AUTHENTICATE_CORRLINKS_USER");
export const LOG_USER_OUT = createAction<any>("LOG_USER_OUT")
